import React from 'react';
import { Star } from 'lucide-react';

const testimonials = [
  {
    text: "I've had ADHD my whole life and I've tried every productivity app. They all let me reschedule endlessly. TickBoom doesn't. When the timer runs out, it records what happened — done or not. That binary is brutal, but it's the only thing that ever worked for me. My task completion rate went from maybe 40% to consistently above 75% in two months.",
    author: 'Sarah M.',
    role: 'Student, ADHD-diagnosed',
    metrics: ['40% → 75% completion', '2 months consistent'],
    initials: 'SM'
  },
  {
    text: "I'm a freelancer and deadlines are everything. The problem was never the deadline itself — it was that I'd tell myself I was working when I really wasn't. TickBoom forced me to actually commit to specific blocks of time. I don't work more hours, I just actually work during the hours I said I would.",
    author: 'Thomas R.',
    role: 'Freelance Designer',
    metrics: ['More output, same hours', '60-day active user'],
    initials: 'TR'
  },
  {
    text: "I started with 10-minute tasks because that felt manageable. Now I'm doing 90-minute deep work sessions. The streak makes me not want to break it — which is exactly the point. It's the first app that made me feel like consistency was actually possible.",
    author: 'Amelia J.',
    role: 'Remote Worker',
    metrics: ['10 min → 90 min sessions', '45-day streak'],
    initials: 'AJ'
  }
];

const Testimonials = () => {
  return (
    <section id="testimonials" className="relative py-32 px-6 lg:px-12" style={{ background: '#08080f' }}>
      <div className="max-w-7xl mx-auto relative z-10">
        {/* Section header */}
        <div className="text-center mb-20 reveal">
          <div className="section-label">User Stories</div>
          <h2 className="text-4xl lg:text-6xl font-black tracking-tight mb-5">
            <span className="gradient-text">Real users.</span>
            <br />
            Real results.
          </h2>
          <p className="text-lg text-[rgba(255,255,255,0.4)] max-w-xl mx-auto">
            Not everyone transforms overnight. But consistency, tracked honestly, compounds.
          </p>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div key={index} className={`cyber-card p-8 flex flex-col reveal delay-${index * 100 + 100}`}>
              {/* Stars */}
              <div className="flex gap-1 mb-6">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={12} className="fill-white text-white opacity-80" />
                ))}
              </div>

              {/* Quote */}
              <p className="text-[rgba(255,255,255,0.65)] leading-relaxed mb-6 flex-1 text-sm">
                "{testimonial.text}"
              </p>

              {/* Metrics */}
              <div className="flex flex-wrap gap-2 mb-6">
                {testimonial.metrics.map((metric, i) => (
                  <span
                    key={i}
                    className="px-2.5 py-1 rounded-md text-xs font-mono text-[rgba(255,255,255,0.4)] border border-[rgba(255,255,255,0.08)]"
                  >
                    {metric}
                  </span>
                ))}
              </div>

              {/* Author */}
              <div className="flex items-center gap-3 pt-5 border-t border-[rgba(255,255,255,0.06)]">
                <div className="w-9 h-9 rounded-full flex items-center justify-center font-bold text-xs flex-shrink-0 text-white" style={{ background: 'linear-gradient(135deg, #7C3AED, #00D26A)' }}>
                  {testimonial.initials}
                </div>
                <div>
                  <div className="font-semibold text-white text-sm">{testimonial.author}</div>
                  <div className="text-xs text-[#6b7280]">{testimonial.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
